/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class StateGroup {

        public state: StateWorkflowBlock;
        public childWorkflowBlocks: IWorkflowBlock[];
        public potentialNextStates: string[]
        
        constructor(state: StateWorkflowBlock, workflowBlocks: IWorkflowBlock[]) {
            this.state = state;
            this.potentialNextStates = [];
            this.childWorkflowBlocks = this.getAllStateWorkflowBlocksInOrder(state, workflowBlocks);
        }

        private getAllByType(blockType: Wars.Domain.Model.Codes.Enums.BlockType) : IWorkflowBlock[] {
            if (blockType === undefined) return [];
            return Enumerable.from(this.childWorkflowBlocks).where(i => i.type === blockType).toArray();
        }

        public getUserActions(): IWorkflowBlock[] {
            return this.getAllByType(Wars.Domain.Model.Codes.Enums.BlockType.UserAction);
        }

        public getMessages(): IWorkflowBlock[] {
            return this.getAllByType(Wars.Domain.Model.Codes.Enums.BlockType.Message);
        }

        public getConditions(): IWorkflowBlock[] {
            return this.getAllByType(Wars.Domain.Model.Codes.Enums.BlockType.Condition);
        }

        public getValidates(): IWorkflowBlock[] {
            return this.getAllByType(Wars.Domain.Model.Codes.Enums.BlockType.Validate);
        }

        public getSendEmailActions(): IWorkflowBlock[] {
            return this.getAllByType(Wars.Domain.Model.Codes.Enums.BlockType.SendEmailAction);
        }

        public getCreatePdfActions(): IWorkflowBlock[] {
            return this.getAllByType(Wars.Domain.Model.Codes.Enums.BlockType.CreatePdfAction);
        }

        public getCopies(): IWorkflowBlock[] {
            return this.getAllByType(Wars.Domain.Model.Codes.Enums.BlockType.Copy);
        }

        public getSetDatas(): IWorkflowBlock[] {
            return this.getAllByType(Wars.Domain.Model.Codes.Enums.BlockType.SetData);
        }

        public getAssignClaims(): IWorkflowBlock[] {
            return this.getAllByType(Wars.Domain.Model.Codes.Enums.BlockType.AssignClaim);
        }

        public getStatusChanges(): string[] {
            var statusNames = [];
            var statusChanges = this.getAllByType(Wars.Domain.Model.Codes.Enums.BlockType.StatusChange);
            for (var index = 0, length = statusChanges.length; index < length; index++) {
                if (statusNames.indexOf(statusChanges[index].label) === -1) {
                    statusNames.push(statusChanges[index].label)
                }
            }
            return statusNames;
        }

        private getAllStateWorkflowBlocksInOrder(stateWorkflowBlock: StateWorkflowBlock, workflowBlocks: IWorkflowBlock[]): IWorkflowBlock[] {
            
            var associatedWorkflowBlocks: IWorkflowBlock[] = [];

            if (!stateWorkflowBlock.toBlockIds || stateWorkflowBlock.toBlockIds.length == 0) return workflowBlocks;

            var currentBlockId = stateWorkflowBlock.toBlockIds[0];
            var currentBlock = Enumerable.from(workflowBlocks).single(i => i.id == currentBlockId);

            var processedBlockIds: string[] = [];
            var pendingBlockIds: string[] = [];

            for (var i = 1; i < stateWorkflowBlock.toBlockIds.length; i++) {
                pendingBlockIds.push(stateWorkflowBlock.toBlockIds[i]);
            }

            while (currentBlock !== undefined && currentBlock !== null) {
                var nextBlock = undefined;
                var nextBlockId = undefined;

                if (processedBlockIds.indexOf(currentBlock.id) === -1) {
                    if (currentBlock.type === Wars.Domain.Model.Codes.Enums.BlockType.State) {
                        if (this.potentialNextStates.indexOf(currentBlock.label) === -1) {
                            this.potentialNextStates.push(currentBlock.label);
                        }
                    } else {
                        processedBlockIds.push(currentBlock.id);
                        associatedWorkflowBlocks.push(currentBlock);

                        // Set Next Block to Process
                        if (currentBlock.toBlockIds && currentBlock.toBlockIds.length > 0) {
                            nextBlockId = currentBlock.toBlockIds[0];
                            nextBlock = Enumerable.from(workflowBlocks).singleOrDefault(i => i.id == nextBlockId);
                            if (nextBlock) {
                                for (var i = 1; i < currentBlock.toBlockIds.length; i++) {
                                    if (pendingBlockIds.indexOf(currentBlock.toBlockIds[i]) === -1) {
                                        pendingBlockIds.push(currentBlock.toBlockIds[i])
                                    }
                                }
                            }
                        }
                    }
                }

                if (nextBlock === undefined && pendingBlockIds.length > 0) {
                    nextBlockId = pendingBlockIds.shift();
                    nextBlock = Enumerable.from(workflowBlocks).singleOrDefault(i => i.id == nextBlockId);
                }

                currentBlock = nextBlock;
            }

            return associatedWorkflowBlocks;
        }
    }
}